import { Sequence } from "@/schema/sequence"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchSequence, fetchSequences } from "./api"

export function useFetchSequences(enabled?: boolean) {
  const getContext = useApiContext()
  const bookId = useBookId()
  return useQuery({
    queryKey: ["sequences", bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchSequences(context)
    },
    enabled,
  })
}

export function useFetchSequence(id: string, options?: Omit<UseQueryOptions<Sequence>, "queryKey" | "queryFn">) {
  const getContext = useApiContext()
  const bookId = useBookId()
  return useQuery({
    queryKey: ["sequence", bookId, id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchSequence(context, id)
    },
    enabled: options?.enabled !== undefined ? options.enabled : !!id,
    ...options,
  })
}
